// w6.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W6 = () => {
  return <WW config={pageConfigs.w6} />;
};

export default W6;
